import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { IconSource } from '../../../apps/categories/ducks/types';
import fontAwesomeGlyphs from './glyphmaps/FontAwesome.json';
import materialCommunityGlyphs from './glyphmaps/MaterialCommunityIcons.json';
import materialGlyphs from './glyphmaps/MaterialIcons.json';
import TikTok from './TikTok';

export type LBIconProps = {
  name?: string;
  source?: IconSource;
  size?: number;
  color?: string;
  className?: string;
};

type GlyphFont = { fontFamily: string; glyphs: Record<string, number> };

const MATERIAL_ICONS: GlyphFont = { fontFamily: 'MaterialIcons', glyphs: materialGlyphs };
const FONT_AWESOME: GlyphFont = { fontFamily: 'FontAwesome', glyphs: fontAwesomeGlyphs };
const MATERIAL_COMMUNITY_ICONS: GlyphFont = {
  fontFamily: 'MaterialCommunityIcons',
  glyphs: materialCommunityGlyphs,
};

// Same reset react-native-web applied to its Text, which these icons were rendered with until now.
const useStyles = makeStyles({
  icon: {
    border: '0 solid black',
    boxSizing: 'border-box',
    color: 'black',
    display: 'inline',
    font: '14px System',
    margin: 0,
    padding: 0,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  },
});

const getGlyphFont = (source: IconSource): GlyphFont => {
  switch (source) {
    case 'FontAwesome':
      return FONT_AWESOME;
    case 'MaterialCommunity':
      return MATERIAL_COMMUNITY_ICONS;
    default:
      return MATERIAL_ICONS;
  }
};

const getGlyph = (glyphs: Record<string, number>, name?: string): string => {
  if (!name) {
    return '';
  }
  const codePoint = glyphs[name];
  return codePoint ? String.fromCodePoint(codePoint) : '?';
};

const IconLB: React.FC<LBIconProps> = ({ source = 'MaterialIcons', size = 23, name, color, className }) => {
  const classes = useStyles();

  if (source === 'Tiktok') {
    return <TikTok size={size} />;
  }

  const { fontFamily, glyphs } = getGlyphFont(source);
  const style = { fontSize: size, color, fontFamily, fontWeight: 'normal', fontStyle: 'normal' } as const;

  return (
    <div className={clsx(classes.icon, className)} style={style}>
      {getGlyph(glyphs, name)}
    </div>
  );
};

export default IconLB;
